import type { WatchQueryFetchPolicy } from "@apollo/client";
import {
  GetQuoteListItemsQueryVariables,
  useGetQuoteListItemsQuery as useGetQuoteListItemsBaseQuery,
} from "@covertree/agent-portal-graphql";

/**
 * Getting Quote list items based on the user's permissions. Executes the proper query and maps the query's result.
 *
 * @returns - quotes list, total count, error and loading state.
 */
export function useGetQuotesListItemsQuery(
  variables: GetQuoteListItemsQueryVariables
) {
  const queryOptions: {
    fetchPolicy: WatchQueryFetchPolicy;
    variables: GetQuoteListItemsQueryVariables;
  } = { fetchPolicy: "cache-and-network", variables };

  const { data, error, loading, previousData } =
    useGetQuoteListItemsBaseQuery(queryOptions);

  return {
    error,
    loading: loading && !data,
    quotes: data?.getQuoteListItems.items ?? [],
    totalCount:
      data?.getQuoteListItems.pagination.total ??
      previousData?.getQuoteListItems.pagination.total ??
      0,
  };
}
